<div class="academy-certifications">
  <section class="academy-certifications__cards-section" aria-label="My Certifications">
    <h2 class="academy-certifications__heading">My Certifications</h2>

    @if (certifications$ | async; as certifications) {
      @if (certifications.length > 0) {
        <div class="academy-certifications__grid">
          @for (cert of certifications; track cert.id) {
            <ut-certification-card [certification]="cert" />
          }
        </div>
      } @else {
        <p class="academy-certifications__empty-message">No certifications are currently available.</p>
      }
    }
  </section>

  <div class="academy-certifications__faq-section">
    <ut-academy-faq [sections]="faqSections" />
  </div>
</div>
